import { RMS_ACTIVITY_OPTIONS, RMS_SOURCE_OPTIONS, getRmsSourceKey } from "../rmsConfigSchema";

export default function RmsPortConfigRow({ row, form, portOptions, onChange }) {
    const portKey = row.key;
    const activityKey = `${portKey}_activity`;
    const sourceKey = getRmsSourceKey(portKey);

    return (
        <div className="rms-port-row">
            <div className="rms-port-row__label">
                <span>{row.label}</span>
                {row.subLabel ? <em className="rms-port-row__sub">{row.subLabel}</em> : null}
            </div>
            <div className="rms-port-row__fields">
                <select
                    className="form-select form-select-sm"
                    value={form[portKey] ?? 0}
                    onChange={(event) => onChange(portKey, Number(event.target.value))}
                >
                    {portOptions.map((option) => (
                        <option key={`${portKey}-port-${option.value}`} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
                <select
                    className="form-select form-select-sm"
                    value={form[activityKey] ?? 0}
                    onChange={(event) => onChange(activityKey, Number(event.target.value))}
                >
                    {RMS_ACTIVITY_OPTIONS.map((option) => (
                        <option key={`${activityKey}-${option.value}`} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
                <select
                    className="form-select form-select-sm"
                    value={form[sourceKey] ?? 1}
                    onChange={(event) => onChange(sourceKey, Number(event.target.value))}
                >
                    {RMS_SOURCE_OPTIONS.map((option) => (
                        <option key={`${sourceKey}-${option.value}`} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
}
